/**
 * Calcula o número de pessoas de um pedido com base no tipo.
 *
 * Regras:
 * - Mesa (table): usa people_count informado no modal. Se não informado, retorna 0 (dado incompleto).
 * - Comanda (tab): cada comanda = 1 pessoa (individual).
 * - Outros (counter, delivery, etc.): usa people_count se disponível, senão 1.
 */
export function getPeopleCount(order: {
  order_type?: string | null;
  people_count?: number | null;
}): number {
  const { order_type, people_count } = order;

  if (order_type === "tab") {
    return 1;
  }

  if (order_type === "table") {
    return people_count && people_count > 0 ? people_count : 0;
  }

  // Outros tipos (counter, delivery, etc.)
  return people_count && people_count > 0 ? people_count : 1;
}
